module.exports = __webpack_public_path__ + "img/avatar3.135b2369.png";